export default __webpack_public_path__ + "static/media/micro-aventure-logo-natural-480x235-red.2c39328a.svg";